<template>
  <div>
    <v-breadcrumbs :items="breadcrumbsItems">
    </v-breadcrumbs>
    <v-data-table
      :headers="headers"
      :items="items"
      dense
      disable-pagination
      hide-default-footer
      hide-default-header
    >
      <template v-slot:item="{ item }">
        <tr @click="openModelsApi(item)" class="link-row">
          <td>{{ item.name }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'CountersModelsResourceTypes',
  data () {
    return {
      items: [],
      loading: true,
      headers: [
        {
          text: 'Наименование',
          align: 'left',
          sortable: true,
          value: 'name'
        }
      ],
      breadcrumbsItems: [
        {
          text: 'Ресурс',
          disabled: true
        }
      ]
    }
  },
  mounted () {
    this.getItemsApi()
  },
  methods: {
    getItemsApi () {
      this.loading = true
      this.axios.get(`/api/resources_types/`)
        .then((response) => {
          this.items = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    openModelsApi (item) {
      this.$router.push({ path: `counters_models_api`, query: { resource_type: item.resource_type_id }})
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/references/CountersModelsResourceTypes.vue